import { render, staticRenderFns } from "./ProfileOverview.vue?vue&type=template&id=0459268e&"
import script from "./ProfileOverview.vue?vue&type=script&lang=js&"
export * from "./ProfileOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports